import { createSlice } from "@reduxjs/toolkit"
import { boolean } from "yup"

const initialState = {
    page: 1,
    selectedValue: 10,
    pageNumber: 1,
    visibleColumns: [
        { name: "Customer Name", visible: false },
        { name: "Customer Number", visible: false },
        { name: "Parent Account Name", visible: false },
        { name: "Account Name", visible: false },
        { name: "Assigned ASP Name", visible: false },
        { name: "Assigned ASP Engineer", visible: false },
        { name: "Address", visible: false },
        { name: "Country", visible: false },
        { name: "State", visible: false },
        { name: "City", visible: false },
        { name: "Pincode", visible: false },
        { name: "Zone", visible: false },
        { name: "Planned Visit Date", visible: false },
        { name: "Part Replaced", visible: false },
        { name: "Total Visit Cost", visible: false },
        { name: "Visit Count", visible: false },
        { name: "Total TAT", visible: false },
        { name: "Statiq Engineer Asssigned at", visible: false },
        { name: "ASP Engineer Assigned at", visible: false },
        // { name: "Complaint Ref id", visible: false },
        { name: "RCA Type", visible: false },
        { name: "RCA Subtype", visible: false },
        { name: "ASP Company Name", visible: false },
        { name: "Raised by", visible: false },
        { name: "Booking ID", visible: false },
    ],
    complaintsFilters: {
        // 0 = My complaints, 1 = All complaints (default).
        all_complaints: 1,
        category: "all",
        complaints_subtype_id: [],
        complaint_type_id: [],
        zone: [],
        country: [],
        status: [],
        state_id: [],
        city_id: [],
        oem_id: [],
        account_id: [],
        search_key: "",
        raised_by_email: "",
        priority: [],
        statiq_engineer_ids: [],
        asp_engineer_ids: [],
        service_complaint_type_id: [],
        service_complaint_subtype_id: [],
        update_complaint_type: [] as any,
        update_complaint_subtype: [],
        assigned_asp_name: [] as any,
        parent_account_id: [],
        resolution_remark_id: [],
        department: [],
        created_at_start: "",
        created_at_end: "",
        part_replacement: "",
        site_visit: "",
        on_hold: "",
        acceptance_status: [],
        charger_type_filter: [],
        source_system: [],
        age_op: "",
        age: [] as number[],
        more_than_age: "",
        between_age1: "",
        between_age2: "",
        less_than_age: "",
    },
    rowData: {},
    tableRowData: {} as any,
    selectedMetric: [],
    displayValues: [],
    currentRules: [],
    selectedTab: 0,
    ticketId: "",
    selectStatus: "",
    dealType: "",
    metricExplicitlyCleared: boolean
}

const ComplaintsSlice = createSlice({
    name: "complaints",
    initialState,
    reducers: {
        setAddAccountForm: (state: any, payload: any) => {
            state.addAccountFormValue = payload?.payload
        },
        setPages: (state, action) => {
            state.page = action?.payload
        },
        setSelectedValues: (state, action) => {
            state.selectedValue = action?.payload
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action?.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
        setComplaintsFilters: (state, action) => {
            state.complaintsFilters = action.payload
        },
        setSelectedTab: (state, action) => {
            state.selectedTab = action?.payload
        },
        setDisplayValues: (state, action) => {
            state.displayValues = action?.payload
        },
        setCurrentRuleValue: (state, action) => {
            state.currentRules = action?.payload
        },
        setSelectedMetric: (state, action) => {
            state.selectedMetric = action?.payload
        },
        setRowData: (state, action) => {
            state.rowData = action?.payload
        },
        setTicketId: (state, payload) => {
            state.ticketId = payload?.payload
        },
        setSelectStatus: (state, payload) => {
            state.selectStatus = payload?.payload
        },
        setDealType: (state, payload) => {
            state.dealType = payload?.payload
        },
        setTableRowData: (state, payload) => {
            state.tableRowData = payload?.payload
        },
        setMetricExplicitlyCleared: (state, action) => {
            state.metricExplicitlyCleared = action.payload
        },
    },
})
export const {
    setAddAccountForm,
    setPages,
    setSelectedValues,
    setPageNumber,
    setVisibleColumns,
    setComplaintsFilters,
    setSelectedTab,
    setDisplayValues,
    setCurrentRuleValue,
    setSelectedMetric,
    setRowData,
    setDealType,
    setTicketId,
    setSelectStatus,
    setTableRowData,
    setMetricExplicitlyCleared
} = ComplaintsSlice.actions
export default ComplaintsSlice.reducer
